import useAuth from '@components/_hooks/useAuth';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import useSafePush from '@components/_hooks/useSafePush';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { CRM_URL, HOME_URL, LOGIN_URL, USER_URL } from '../utilities/constants';


const useAuthNavigation = () => {
    const global_settings = useSelector(state => state.globalReducer.global_settings);
    const template_settings = useSelector(state => state.globalReducer.template_settings);
    const {user, is_agent} = useAuth();
    const {getSetting} = useGlobalSettings();
    const {safePush} = useSafePush();
    const showLoginText = (global_settings.portal_status && global_settings.portal_status == 'enabled') || (template_settings.portal_status && template_settings.portal_status == 'enabled');

    const accountButtonAction = (callback) => {
        if(user){
            if(is_agent){
                safePush(CRM_URL);
            }
            else if(getSetting('crm_type', 'default') != 'basic'){
                if(typeof callback == 'function') callback();
                else safePush(USER_URL);
            } else if (getSetting('crm_type', 'default') == 'basic') {
                if(typeof callback == 'function') callback();
                else safePush(USER_URL);
            }
            else {  
                safePush(HOME_URL);
            }
        }
        else {
            safePush(LOGIN_URL);
        }
        //   return process.env.NEXT_PUBLIC_USER_LOGIN_URL;
    }

    return {showLoginText, accountButtonAction}
}

export default useAuthNavigation;